export interface Channel {
  slug: string;
  name: string;
  tagline: string;
  desc: string;
  cover: string;
  accent: 'primary' | 'accent' | 'secondary';
}

export const channels: Channel[] = [
  {
    slug: 'bagua',
    name: '娱乐八卦',
    tagline: '圈内瓜田，天天有料',
    desc: '艺人恋情、剧组动向、综艺名场面，聚焦娱乐圈里最热的新鲜瓜，追热点不吃亏。',
    cover: 'https://readdy.ai/api/search-image?query=editorial%20collage%20of%20glittering%20stage%20spotlight%20and%20film%20awards%20trophy%20silhouettes%20on%20soft%20warm%20peach%20background%2C%20vibrant%20magazine%20style%2C%20subtle%20confetti%20and%20bokeh%2C%20cheerful%20entertainment%20media%20illustration&width=1200&height=760&seq=ch-bagua-01&orientation=landscape',
    accent: 'primary',
  },
  {
    slug: 'mingxing',
    name: '明星资讯',
    tagline: '明星动态，一手掌握',
    desc: '艺人行程、采访实录、造型街拍与口碑观察，带你了解聚光灯背后的真实一面。',
    cover: 'https://readdy.ai/api/search-image?query=stylish%20celebrity%20portrait%20backstage%20with%20soft%20ring%20light%20and%20cream%20colored%20minimalist%20set%2C%20elegant%20fashion%20editorial%20photography%2C%20warm%20lighting%2C%20glamorous%20but%20tasteful&width=1200&height=760&seq=ch-mingxing-02&orientation=landscape',
    accent: 'secondary',
  },
  {
    slug: 'wanghong',
    name: '网红爆料',
    tagline: '网红内幕，反转连连',
    desc: '主播涨粉秘辛、直播名场面、品牌争议与幕后团队，拆解流量时代的爆火与翻车。',
    cover: 'https://readdy.ai/api/search-image?query=neon%20glowing%20smartphone%20and%20ring%20light%20on%20a%20dark%20teal%20studio%20desk%2C%20live%20streaming%20vibe%2C%20colorful%20notifications%20and%20like%20icons%2C%20modern%20digital%20influencer%20illustration&width=1200&height=760&seq=ch-wanghong-03&orientation=landscape',
    accent: 'accent',
  },
  {
    slug: 'yingshi',
    name: '影视综艺',
    tagline: '好剧好综，热评不断',
    desc: '新剧开播、热综名场面、演技点评与追更指南，帮你选出值得熬夜的下饭好内容。',
    cover: 'https://readdy.ai/api/search-image?query=cinema%20theater%20interior%20with%20red%20velvet%20seats%20and%20warm%20projector%20light%20beam%2C%20popcorn%20and%20film%20reel%20silhouette%2C%20cozy%20movie%20night%20editorial%20illustration%20with%20soft%20warm%20tones&width=1200&height=760&seq=ch-yingshi-04&orientation=landscape',
    accent: 'primary',
  },
  {
    slug: 'shehui',
    name: '社会热点',
    tagline: '人间百态，理性吃瓜',
    desc: '网络热议的公共事件、民生议题与青年话题，在围观之余也带来冷静的视角。',
    cover: 'https://readdy.ai/api/search-image?query=diverse%20crowd%20in%20warm%20sunlight%20gathered%20around%20a%20megaphone%20and%20debate%20bubbles%2C%20soft%20abstract%20community%20illustration%2C%20terracotta%20and%20sand%20tones%2C%20thoughtful%20and%20optimistic%20mood&width=1200&height=760&seq=ch-shehui-05&orientation=landscape',
    accent: 'secondary',
  },
];

export function getChannel(slug: string): Channel | undefined {
  return channels.find((c) => c.slug === slug);
}